import css from "../cooperation/cooperation.module.css";
import { Heading } from "@idg-web-platform/pulse";
import { NavigationWrapper } from "../../components/navigation/navigationWrapper.tsx";
import SSI from "../../ssi.tsx";
import { useEffect } from "preact/hooks";
import { analyticsContentViewed } from "../../utils/analyticsContentViewed.ts";

CooperationPage.tagName = "control-cooperation-page";

export function CooperationPage() {
  useEffect(() => {
    analyticsContentViewed("cooperation");
  }, []);

  return (
    <>
      <NavigationWrapper currentPath="/c/account/cooperation">
        <div className={css.heading}>
          <Heading text={"Kooperationsangebote"} sizeStep={2} />
          <SSI url={"/fragments/d/cooperation-offers"} />
        </div>
      </NavigationWrapper>
    </>
  );
}
